<script setup lang="ts">
import { useSEO } from "~/composables/useSeo";
import { useResumeStore } from "~/stores/useResumeStore";

const store = useResumeStore();
await store.loadResumeData();

useSEO({
  title: `${store.personalInformation?.name} - Projects & Experience`,
  description:
    "Browse my professional journey through a comprehensive timeline of projects and work experience, showcasing technical expertise and creative problem-solving.",
});
</script>

<template>
  <PagesProjects :experiences="store.experiences" />
</template>
